export const removeUnderscores = (str) => {
  return str.replace(/_/g, " ");
};

//str.split('_').join(' ');
